import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { setupCapacitorPush } from './utils/capacitorPush';

/* Core CSS required for Ionic components to work properly */
import '@ionic/react/css/core.css';

/* Basic CSS for apps built with Ionic */
import '@ionic/react/css/normalize.css';
import '@ionic/react/css/structure.css';
import '@ionic/react/css/typography.css';

/* Optional CSS utils that can be enabled */
import '@ionic/react/css/padding.css';
import '@ionic/react/css/float-elements.css';
import '@ionic/react/css/text-alignment.css';
import '@ionic/react/css/text-transformation.css';
import '@ionic/react/css/flex-utils.css';
import '@ionic/react/css/display.css';

import './index.css';

import { setupIonicReact } from '@ionic/react';
import { SettingsProvider } from './context/SettingsContext';
import { updateNativeStatusBar } from './utils/statusBar';

setupIonicReact({
  mode: 'md', // Force Material Design for a consistent SaaS look across platforms
});

try {
  const storedTheme = localStorage.getItem('theme') || 'system';
  const systemDark = window.matchMedia?.('(prefers-color-scheme: dark)')?.matches ?? false;
  const resolvedTheme = storedTheme === 'system' ? (systemDark ? 'dark' : 'light') : storedTheme;
  const isDark = resolvedTheme === 'dark';
  document.documentElement.classList.toggle('dark', isDark);
  updateNativeStatusBar(isDark);
} catch (e) {
  // localStorage blocked (private mode / old browser) — default to light theme
  document.documentElement.classList.remove('dark');
  updateNativeStatusBar(false);
}

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <SettingsProvider>
      <App />
    </SettingsProvider>
  </React.StrictMode>
);

// Initialize Capacitor Push Notifications
setupCapacitorPush();

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
